var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 20,
    viewBox: "0 0 29 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 0H4.88889C3.59227 0 2.34877 0.515078 1.43192 1.43192C0.515078 2.34877 0 3.59227 0 4.88889V15.1111C0 16.4077 0.515078 17.6512 1.43192 18.5681C2.34877 19.4849 3.59227 20 4.88889 20H24C25.2966 20 26.5401 19.4849 27.457 18.5681C28.3738 17.6512 28.8889 16.4077 28.8889 15.1111V4.88889C28.8889 3.59227 28.3738 2.34877 27.457 1.43192C26.5401 0.515078 25.2966 0 24 0ZM15.6667 12.2222L11.3333 14.4444V5.55556L15.6667 7.77778L20 10L15.6667 12.2222Z",
    fill: "#FFF7F2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.170685d60831e904e54471ec3a9d1895.svg";
export { ForwardRef as ReactComponent };